import api from './api';
import { handleResponse, handleError } from './api';

const portalAdminService = {
  async getHome() {
    try { return handleResponse(await api.get('/portal/admin/home')); }
    catch (e) { return handleError(e); }
  },

  async listApplications(status = 'pending', page = 1, pageSize = 25) {
    try {
      const params = new URLSearchParams({ page: String(page), pageSize: String(pageSize) });
      if (status) params.set('status', status);
      return handleResponse(await api.get(`/portal/admin/applications?${params.toString()}`));
    } catch (e) { return handleError(e); }
  },

  async getApplication(id) {
    try { return handleResponse(await api.get(`/portal/admin/applications/${id}`)); }
    catch (e) { return handleError(e); }
  },

  async reviewApplication(id, { action, decisionNote }) {
    try { return handleResponse(await api.post(`/portal/admin/applications/${id}/review`, { action, decisionNote })); }
    catch (e) { return handleError(e); }
  },

  async listMembers({ search, city, page = 1, pageSize = 50 } = {}) {
    try {
      const params = new URLSearchParams({ page: String(page), pageSize: String(pageSize) });
      if (search) params.set('search', search);
      if (city) params.set('city', city);
      return handleResponse(await api.get(`/portal/admin/members?${params.toString()}`));
    } catch (e) { return handleError(e); }
  },

  async getMember(userId) {
    try { return handleResponse(await api.get(`/portal/admin/members/${userId}`)); }
    catch (e) { return handleError(e); }
  },

  async removeMember(userId) {
    try {
      const r = await api.delete(`/portal/admin/members/${userId}`);
      return { success: r.status >= 200 && r.status < 300, data: null, error: null };
    } catch (e) { return handleError(e); }
  },

  // tier: 'member' (5 keys) | 'key_holder' (unlimited)
  async setKeyTier(userId, tier) {
    try {
      const r = await api.post(`/portal/admin/members/${userId}/key-tier`, { userId, tier });
      return { success: r.status >= 200 && r.status < 300, data: null, error: null };
    } catch (e) { return handleError(e); }
  },

  async listAdmins() {
    try { return handleResponse(await api.get('/portal/admin/admins')); }
    catch (e) { return handleError(e); }
  },

  async promoteAdmin(userId) {
    try {
      const r = await api.post('/portal/admin/admins', { userId });
      return { success: r.status >= 200 && r.status < 300, data: null, error: null };
    } catch (e) { return handleError(e); }
  },

  async demoteAdmin(userId) {
    try {
      const r = await api.delete(`/portal/admin/admins/${userId}`);
      return { success: r.status >= 200 && r.status < 300, data: null, error: null };
    } catch (e) { return handleError(e); }
  },

  async promoteToOwner({ newOwnerUserId, confirmHandle }) {
    try {
      const r = await api.post('/portal/admin/owner/transfer', { newOwnerUserId, confirmHandle });
      return { success: r.status >= 200 && r.status < 300, data: null, error: null };
    } catch (e) { return handleError(e); }
  },

  async stepDownFromOwner() {
    try {
      const r = await api.post('/portal/admin/owner/step-down');
      return { success: r.status >= 200 && r.status < 300, data: null, error: null };
    } catch (e) { return handleError(e); }
  },
};

export default portalAdminService;
